import { API_ROOT } from '../config';
import request from '../utils/request';

export function login({ username, password }) {
  const params = new URLSearchParams();
  params.append('username', username);
  params.append('password', password);
  return request('/api/login', {
    method: 'POST',
    body: params,
  });
}

// ccadmin — отдельное приложение со своей сессией (cookie Path=/ccadmin).
// Используем fetch напрямую: 401 от ccadmin не должен вызывать logoutUser() из request().
export function ccadminLogin({ username, password }) {
  const params = new URLSearchParams();
  params.append('username', username);
  params.append('password', password);
  return fetch(`${API_ROOT}/ccadmin/login`, {
    method: 'POST',
    credentials: 'include',
    headers: { Accept: 'application/json' },
    body: params,
  }).then((response) => {
    if (!response.ok) throw new Error(`ccadmin login failed: ${response.status}`);
    return response;
  });
}

export function logout() {
  return request('/api/logout');
}

export function ccadminLogout() {
  return fetch(`${API_ROOT}/ccadmin/logout`, { credentials: 'include' });
}
export const sendResetEmail = async ({ email }) => {
  // фейковая имитация запроса на создание письма
  return new Promise((resolve) => {
    // eslint-disable-next-line no-console
    console.log('[API] sendResetEmail →', email);
    setTimeout(() => resolve({ ok: true }), 700);
  });
};

export const confirmResetPassword = async ({ token, password }) => {
  // фейковая имитация подтверждения сброса
  return new Promise((resolve, reject) => {
    // eslint-disable-next-line no-console
    console.log('[API] confirmResetPassword →', { token, passwordLen: password?.length });
    setTimeout(() => {
      if (!token) return reject(new Error('Bad token'));
      resolve({ ok: true });
    }, 700);
  });
};

export async function passwordRecoveryRequest(email) {
  return request('/api/v1/password-recovery/request', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: { email },
  });
}

export async function passwordRecoveryVerify({ token, code }) {
  return request('/api/v1/password-recovery/verify', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: { token, code },
  });
}

export async function passwordRecoveryReset({ token, newPassword }) {
  return request('/api/v1/password-recovery/reset', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: { token, newPassword },
  });
}
export function logCaseVisit(caseName) {
  if (!caseName) {
    return Promise.resolve();
  }

  return request('/api/v1/case-visits', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: { caseName },
  });
}
export function getUserAccessAttempts(userId) {
  if (!userId && userId !== 0) {
    return Promise.resolve([]);
  }

  return request(`/api/v1/access-attempts/users/${userId}`);
}
